export default function CrossIcon({ label = 'Zavřít', ...restProps }) {
	return (
		<svg
			version='1.1'
			viewBox='0 0 32 32'
			aria-label={label}
			focusable={false}
			xmlns='http://www.w3.org/2000/svg'
			{...restProps}
		>
			<g fill='currentColor'>
				<path d='M.44 28.73L28.73.44l2.83 2.83L3.27 31.56.44 28.73z' />
				<path d='M31.56 28.73L3.27.44.44 3.27l28.29 28.29 2.83-2.83z' />
			</g>
		</svg>
	);
}
